import React from 'react';
import { IconProps } from './typing';

const GoBack = ({
  iconSize = 24,
  background = 'none',
  color = 'currentColor',
}: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${Math.floor(iconSize * 0.7) + 1}`}
    fill={background}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.003 6.53216H2.12563C3.09473 5.51506 4.78783 3.83346 6.89013 1.94996L6.00243 0.959961C5.94243 1.01366 0.00292969 6.34376 0.00292969 7.19726C0.00292969 8.07416 5.94293 13.4336 6.00243 13.4873L6.89013 12.4973C4.78523 10.612 3.07763 8.89656 2.10803 7.86246H20.003V6.53216Z"
      fill={color}
    />
  </svg>
);

export default GoBack;
